



































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapActions, mapGetters, mapState } from 'vuex';
import SectionLoader from '@/components/SectionLoader.vue';
import ACHAccount from '@/models/ACHAccount';
import Customer from '@/models/Customer';

export default Vue.extend({
	name: 'SecureAchForm',
	components: { SectionLoader },

	inject: ['$validator'],

	props: {
		location: { type: Object, required: true },
		required: { type: Boolean, default: false },
		validate: { type: Boolean, default: false },
	},

	computed: {
		...mapState(['paths']),
		...mapState('location', ['token']),

		stylesheet(): string {
			return this.paths.css ? escape(encodeURIComponent(this.paths.css)) : '';
		},

		url(): string {
			const params: { [key: string]: any } = {
				location: this.location.code,
				required: this.required,
				sub: this.location.subLocation,
				token: this.token,
			};

			let base = 'https://eparking.us/ach.php';
			if ((this.location.server_environment as string) === 'development') {
				base = 'https://eparking.demo.netpark.us/ach.php'
			} else if ((this.location.server_environment as string) === 'local') {
				base = 'http://eparking.local/ach.php'
			}

			const paramsString = Object.keys(params).reduce((carry, key) => {
				let paramString = carry;
				paramString += !carry ? '?' : '&';
				paramString += `${key}=${params[key]}`;

				return paramString;
			}, '');

			return `${base}${paramsString}`;
		},
	},

	data() {
		return {
			errorCount: 0,
			iframeHeight: '0px',
			loading: false,
		};
	},

	async created() {
		if (!this.token) {
			this.loading = true;
			await this.fetchToken(this.location);
			this.loading = false;
		}

		window.addEventListener('message', (event) => {
			try {
				if (event.data.size) {
					this.resizeFrame(event.data.size);
				}

				if (event.data.errors && Object.keys(event.data.errors).length) {
					this.handleErrors(event.data.errors);
				}

				if (event.data.ach_token) {
					this.handleValidToken(event.data);
				}
			} catch (error) {
				/* Missing event data */
			}
		}, false);
	},

	methods: {
		...mapActions('location', ['fetchToken']),

		error() {
			if (this.errorCount > 3) {
				return;
			}

			this.errorCount += 1;
			const frame = this.$refs.iframe as HTMLIFrameElement;
			frame.src = '';
			frame.src = this.url;
		},

		handleErrors(errors: any) {
			this.$nextTick(() => {
				this.$emit('on-tokenize', errors);
			});
		},

		handleValidToken(data: any) {
			const account = new ACHAccount({
				number: data.ach_number,
				token: data.ach_token,
			});

			this.$nextTick(() => {
				this.$emit('on-tokenize', account);
			});
		},

		resizeFrame(size: number | string) {
			if (typeof size === 'number') {
				size = `${size}px`;
			}

			this.iframeHeight = size;
		},

		sendMessage(data: any) {
			((this.$refs.iframe as HTMLIFrameElement).contentWindow as any).postMessage(data, '*');
		},

		submit() {
			this.sendMessage({ action: 'tokenize' });
		},
	},

	watch: {
		validate(newValue, oldValue) {
			if (newValue === true && oldValue === false) {
				this.submit();
			}
		},
	},
});
